<form class="overflow-auto survey">
  <div nz-row [nzGutter]="0">
    <div nz-col nzSm="1" nzMd="1" nzLg="1" nzXl="2">
    </div>
    <div class="content" nz-col nzSm="22" nzMd="22" nzLg="22" nzXl="20">
      <nz-card>
        <div class="flex justify-between">
            <div class="img-logo">
              <img src="./assets/img/logo-projects/Logo.png">
            </div>
            <div class="code">
              <span>
                Mã Phiếu
              </span>
              <input class="input-form-code" />
              <div class="form-code">
                <div>
                  <input *ngFor="let inp of inputCode" type="text" max="1">
                </div>
                <div>
                  <input *ngFor="let inp of inputCode" type="text" max="1">
                </div>

              </div>
            </div>
        </div>
        <div class="description">
          <h4 class="title">
            PHIẾU HỎI DÀNH CHO GIÁO VIÊN DẠY HỌC NGƯỜI KHUYẾT TẬT
          </h4>
          <p class="indent">
            Để thu thập dữ liệu cho quản lý giáo dục người khuyết tật Việt Nam, Mong Thầy/cô vui lòng cung cấp thông tin theo các nội dung dưới đây bằng cách <span class="bold">đánh dấu (X) vào • phương án lựa chọn hoặc điền thông tin vào các chỗ (……).</span> Các thông tin chỉ được dùng cho mục đích chăm sóc giáo dục người khuyết tật. Mọi thông tin cá nhân được bảo mật.
          </p>
              <h4 class="title second">
                A. Thông tin chung
              </h4>
              <div class="item-form">
                <div nz-row [nzGutter]="[24,24]" >
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'fullName'" #label nzRequired="true">Họ và tên</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="staffSurvey.fullName ? '' : 'error'">
                        <input nz-input [(ngModel)]="staffSurvey.fullName" [ngModelOptions]="{standalone :true}"/>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'gender'" #label nzRequired="true">Giới tính</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="staffSurvey.gender ? '' : 'error'">
                        <nz-radio-group [(ngModel)]="staffSurvey.gender" [ngModelOptions]="{standalone :true}">
                          <label nz-radio [nzValue]="1">Nam</label>
                          <label nz-radio [nzValue]="0">Nữ</label>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'yearOfBirth'" #label class="text-right year-label" nzRequired="true">Năm sinh</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="staffSurvey.yearOfBirth ? '' : 'error'">
                        <nz-input-number [(ngModel)]="staffSurvey.yearOfBirth" [nzMin]="1900" [nzMax]="yearNow" [nzStep]="1" [ngModelOptions]="{standalone :true}"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="8">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'folkId'" #label>5. Dân tộc</nz-form-label>
                      <nz-form-control>
                        <asc-autocomplete [ascModel]="FolkControl" (ascModelChange)="changeFolk($event)" [placeholder]="'Chọn dân tộc'" [getListAC]="getFolkACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'yearsOfService'" #label>Số năm công tác dạy học</nz-form-label>
                      <nz-form-control>
                        <nz-input-number [(ngModel)]="staffSurvey.yearsOfService" [nzMin]="1" [nzMax]="100" [nzStep]="1" [ngModelOptions]="{standalone :true}"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'yearsOfTeaching'" #label class="text-right" >Số năm dạy học người khuyết tật</nz-form-label>
                      <nz-form-control>
                        <nz-input-number [(ngModel)]="staffSurvey.yearsOfTeaching" [nzMin]="1" [nzMax]="100" [nzStep]="1" [ngModelOptions]="{standalone :true}"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label>
                        Chuyên ngành đào tạo
                      </nz-form-label>
                      <nz-form-control>
                        <asc-autocomplete label="Chuyên ngành đào tạo" [ascModel]="MajorControl"
                        (ascModelChange)="changeMajor($event)" placeholder="Chọn chuyên ngành đào tạo..."
                        [getListAC]="getMajorACFn"> 
                    </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label nzRequired="true" [nzFor]="'qualificationId'" #label>
                        Trình độ đào tạo
                      </nz-form-label>
                      <nz-form-control [nzValidateStatus]="staffSurvey.qualificationId ? '' : 'error'" nzErrorTip="Nhập trường thông tin bắt buộc">
                        <asc-autocomplete  [ascModel]="QualificationControl"
                          (ascModelChange)="changeQualification($event)" placeholder="Chọn trình độ đào tạo..."
                          [getListAC]="getQualificationACFn">
                      </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'field'" [nzSpan]="24" nzRequired="true" #label>
                        <b>Đào tạo bồi dưỡng về giáo dục người khuyết tật</b>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24" nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="staffSurvey.staffUnfostered !== undefined ? '' : 'error'">
                        <nz-radio-group [ngModel]="staffSurvey.staffUnfostered" (ngModelChange)="staffUnfosteredlChange($event)" [ngModelOptions]="{standalone: true}" class="w-full">
                          <div nz-row [nzGutter]="[24,12]">
                            <div nz-col [nzSpan]="24">
                              <nz-form-label [nzFor]="'field'" [nzSpan]="24">
                                <label nz-radio [nzValue]="false">Chưa</label>
                              </nz-form-label>
                            </div>
                            <div nz-col [nzSpan]="24" class="flex">
                              <nz-form-label [nzFor]="'field'">
                                <label nz-radio [nzValue]="true">Có</label>
                              </nz-form-label>
                              <div nz-row [nzGutter]="[24,24]" class="w-full">
                                <div nz-col [nzSpan]="6" *ngFor="let diploma of listDiploma; let i = index">
                                  <nz-form-item>
                                    <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                      <label 
                                        nz-checkbox 
                                        [nzTooltipTitle]="diploma.name" 
                                        nz-tooltip 
                                        nz-checkbox 
                                        [ngModel]="diploma.checked" 
                                        (ngModelChange)="diplomaChange($event, i)" 
                                        [ngModelOptions]="{standalone :true}"
                                        [nzDisabled]="!staffSurvey.staffUnfostered"
                                        >
                                        {{ diploma.name }}
                                      </label>
                                    </nz-form-label>
                                  </nz-form-item>
                                </div>
                              </div>  
                            </div>
                          </div>    
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </div>
              <h4 class="title second">
                <nz-form-label [nzFor]="'listStudentSurveyLevelOfDevelopment'"  [nzNoColon]="true" #label>
                  <h4 class="title second">
                    B. Nội dung khảo sát
                  </h4>
                </nz-form-label>
              </h4>
              <div class="item-form">
                <!-- 1. Các hoạt động dạy học -->
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'field'">
                        <span>
                          <b>1. Các hoạt động dạy học và hỗ trợ người khuyết tật thầy/cô đã từng tham gia?</b>
                        </span>
                      </nz-form-label>
                    </nz-form-item>
                  </div>
                  <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'">
                          <b>Các hoạt động dạy học và hỗ trợ người khuyết tật</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="6">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Tham gia</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="10">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Mức độ kỹ năng</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <ng-container *ngFor="let teachingAndSupport of listTeachingAndSupport; let i = index">
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            {{ i+1 }}. {{ teachingAndSupport.name }}
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="6">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true">
                            <nz-radio-group [ngModel]="teachingAndSupport.hasJoined" (ngModelChange)="hasJoinedTASChange($event, i)" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="true">Có</label>
                              <label nz-radio [nzValue]="false">Không</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="10">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true">
                            <nz-radio-group [(ngModel)]="teachingAndSupport.skillLevelId" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="1">Thành thạo</label>
                              <label nz-radio [nzValue]="2">Chưa thành thạo</label>
                              <label nz-radio [nzValue]="3">Chưa có</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <!-- 2. KHGDCN của người học do ai tham gia xây dựng và thực hiện? -->
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <b>2. KHGDCN của người học do ai tham gia xây dựng và thực hiện?</b>
                    <br>
                    <span class="italic">(Dành cho thầy cô đã tham gia xây dựng kế hoạch giáo dục cá nhân)</span>
                  </div>
                  <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Người tham gia</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Xây dựng</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Thực hiện</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <ng-container *ngFor="let participants of listParticipants; let i = index">
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            {{ i+1 }}. {{ participants.name }}
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [ngModel]="participants.hasBuild" (ngModelChange)="hasBuildParticipantsChange($event, i)" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="true">Có</label>
                              <label nz-radio [nzValue]="false">Không</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [(ngModel)]="participants.hasMade" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="true">Có</label>
                              <label nz-radio [nzValue]="false">Không</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                    </ng-container>
                    <div nz-col [nzSpan]="6">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'">
                          Đánh giá về kết quả
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="18">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                          <nz-radio-group [(ngModel)]="staffSurvey.evaluationResult" [ngModelOptions]="{standalone :true}">
                            <label nz-radio [nzValue]="1">Tốt</label>
                            <label nz-radio [nzValue]="2">Đạt</label>
                            <label nz-radio [nzValue]="3">Chưa đạt</label>
                          </nz-radio-group>
                        </nz-form-label>
                      </nz-form-item>
                    </div>              
                  </div>
                </div>
                <!--3. Thầy cô cho ý kiến về việc thực hiện điều chỉnh trong giáo dục người khuyết tật?-->
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <b>3. Thầy cô cho ý kiến về việc thực hiện điều chỉnh trong giáo dục người khuyết tật?</b>
                  </div>
                  <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Nội dung điều chỉnh</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Thực hiện</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Mức độ thực hiện</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <ng-container *ngFor="let adjustContent of listAdjustContents; let i = index">
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            {{ i+1 }}. {{ adjustContent.name }}
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [ngModel]="adjustContent.hasMade" (ngModelChange)="hasMadeACChange($event, i)" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="true">Có</label>
                              <label nz-radio [nzValue]="false">Không</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [(ngModel)]="adjustContent.levelBuild" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="1">Tốt</label>
                              <label nz-radio [nzValue]="2">Đạt</label>
                              <label nz-radio [nzValue]="3">Chưa đạt</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <!-- 4. Thầy cô cho ý kiến về cơ sở vật chất, phương tiện và thiết bị giáo dục người khuyết tật? -->
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <b>4. Thầy cô cho ý kiến về cơ sở vật chất, phương tiện và thiết bị giáo dục người khuyết tật?</b>
                  </div>
                  <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Nội dung điều chỉnh</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Thực hiện</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="8">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Mức độ thực hiện</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <ng-container *ngFor="let facilitiesAndEquipment of listFacilitiesAndEquipment; let i = index">
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            {{ i+1 }}. {{ facilitiesAndEquipment.name }}
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [ngModel]="facilitiesAndEquipment.amountStatus" (ngModelChange)="amountStatusFAEChange($event,i)" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="1">Không có</label>
                              <label nz-radio [nzValue]="2">Thiếu</label>
                              <label nz-radio [nzValue]="3">Đủ</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [(ngModel)]="facilitiesAndEquipment.quantityStatus" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="1">Tốt</label>
                              <label nz-radio [nzValue]="2">Đạt</label>
                              <label nz-radio [nzValue]="3">Chưa đạt</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <!-- 5. Thầy cô cho ý kiến về kết quả áp dụng các nội dung đã được đào tạo, bồi dưỡng về giáo dục người khuyết tật -->
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <b>5. Thầy cô cho ý kiến về kết quả áp dụng các nội dung đã được đào tạo, bồi dưỡng về giáo dục người khuyết tật</b>
                  </div>
                  <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
                    <div nz-col [nzSpan]="6">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Nội dung về giáo dục người khuyết tật</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="6">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Tham gia</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="6">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Áp dụng</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="6">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Kết quả áp dụng</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <ng-container *ngFor="let trainingAndRetraining of listTrainingAndRetraining; let i = index">
                      <div nz-col [nzSpan]="6">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            <span [nzTooltipTitle]="trainingAndRetraining.name" nz-tooltip>
                              {{ i+1 }}. {{ trainingAndRetraining.name }}
                            </span>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="6">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [ngModel]="trainingAndRetraining.hasJoined" (ngModelChange)="hasJoinedTARChange($event, i)" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="false">Chưa</label>
                              <label nz-radio [nzValue]="true">Đã tham gia</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="6">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [ngModel]="trainingAndRetraining.applied" [ngModelOptions]="{standalone :true}" (ngModelChange)="appliedTARChange($event, i)">
                              <label nz-radio [nzValue]="false">Chưa</label>
                              <label nz-radio [nzValue]="true">Đã áp dụng</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="6">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [(ngModel)]="trainingAndRetraining.resultsInApplied" [ngModelOptions]="{standalone :true}" >
                              <label nz-radio [nzValue]="1">Tốt</label>
                              <label nz-radio [nzValue]="2">Đạt</label>
                              <label nz-radio [nzValue]="3">Chưa đạt</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <!-- 6. Chế độ của thầy/cô khi tham gia giáo dục người khuyết tật -->
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <b>6. Chế độ của thầy/cô khi tham gia giáo dục người khuyết tật</b>
                  </div>
                  <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
                    <div nz-col [nzSpan]="12">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Chế độ</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="12">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                          <b>Việc thực hiện</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <ng-container *ngFor="let participationMode of listParticipationMode; let i = index">
                      <div nz-col [nzSpan]="12">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            {{ i+1 }}. {{ participationMode.name }}
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="12">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" nzNoColon="true" class="text-center">
                            <nz-radio-group [(ngModel)]="participationMode.hasMade" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="true">Có</label>
                              <label nz-radio [nzValue]="false">Không</label>
                            </nz-radio-group>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <!-- 7. Thầy cô cho ý kiến về sự phối hợp của lực lượng trong quá trình GD người khuyết tật(gia đình - nhà trường - cộng đồng) -->
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label [nzFor]="'field'" [nzSpan]="24">
                      <b>7. Thầy cô cho ý kiến về sự phối hợp của lực lượng trong quá trình GD người khuyết tật (gia đình - nhà trường - cộng đồng)</b>
                    </nz-form-label>
                    <nz-form-control [nzSpan]="24">
                      <nz-radio-group [ngModel]="staffSurvey.isCoordinationAsfac" (ngModelChange)="isCoordinationChange($event)" [ngModelOptions]="{standalone :true}" class="w-full">
                        <div nz-row [nzGutter]="[0,0]">
                          <div nz-col [nzSpan]="24">
                            <nz-form-label [nzFor]="'field'" [nzSpan]="24">
                              <label nz-radio [nzValue]="false">Chưa</label>
                            </nz-form-label>
                          </div>
                          <div nz-col [nzSpan]="24" class="flex">
                            <nz-form-label [nzFor]="'field'">
                              <label nz-radio [nzValue]="true">Có</label>
                            </nz-form-label>
                            <div nz-row [nzGutter]="[0,0]" class="w-full">
                              <div nz-col [nzSpan]="24" class="flex items-center w-full">
                                <nz-form-item class="w-full">
                                  <nz-radio-group [(ngModel)]="staffSurvey.coordinationAsfacId" [ngModelOptions]="{standalone :true}" [nzDisabled]="!staffSurvey.isCoordinationAsfac">
                                    <label class="y-kien" *ngFor="let coordination of listCoordination" nz-radio [nzValue]="coordination.id">{{ coordination.name }}</label>
                                  </nz-radio-group>
                                </nz-form-item>
                              </div>
                            </div>  
                          </div>
                        </div>    
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <!-- 8. Thầy/cô cho biết những khó khăn gặp phải trong quá trình thực hiện GD người khuyết tật -->
                <div nz-col [nzSpan]="24">
                  <div nz-row [nzGutter]="[0,24]" class="w-full">
                    <div nz-col [nzSpan]="24">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'listStudentSurveyInformationSource'" #label>
                          <b>8. Thầy/cô cho biết những khó khăn gặp phải trong quá trình thực hiện GD người khuyết tật?</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
                      <ng-container *ngFor="let difficultyInEducations of listDifficultyInEducations; let i = index">
                        <div nz-col [nzSpan]="24" *ngIf="!difficultyInEducations.isRequiredNote">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                              <label nz-checkbox [ngModel]="difficultyInEducations.checked" (ngModelChange)="difficultyInEducationsChange($event,i)" [ngModelOptions]="{standalone :true}">{{ difficultyInEducations.name }}</label>
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                        <ng-container *ngIf="difficultyInEducations.isRequiredNote">
                          <div nz-col [nzSpan]="12">
                            <nz-form-item>
                              <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                <label nz-checkbox [ngModel]="difficultyInEducations.checked" (ngModelChange)="difficultyInEducationsChange($event,i)" [ngModelOptions]="{standalone :true}">{{ difficultyInEducations.name }}</label>
                              </nz-form-label>
                            </nz-form-item>
                          </div>
                          <div nz-col [nzSpan]="12">
                            <nz-form-item>
                              <nz-form-label [nzFor]="'field'">
                                <i class="fas fa-circle"></i>
                                Nhập khi chọn loại "khác"
                              </nz-form-label>
                              <nz-form-control>
                                <input nz-input [(ngModel)]="staffSurvey.difficultyInEducationOther" [ngModelOptions]="{standalone :true}" [disabled]="!this.listDifficultyInEducations[i].checked"/>
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- 9. Để thực hiện GD người khuyết tật tốt hơn thầy/cô có mong muốn gì? -->
                <div nz-col [nzSpan]="24">
                  <div nz-row [nzGutter]="[0,24]" class="w-full">
                    <div nz-col [nzSpan]="24">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'listStudentSurveyInformationSource'" #label>
                          <b>9. Để thực hiện GD người khuyết tật tốt hơn thầy/cô có mong muốn gì?</b>
                        </nz-form-label>
                      </nz-form-item>
                    </div>
                    <div nz-row [nzGutter]="[24,12]" class="pl-8 pb-8">
                      <ng-container *ngFor="let teachersDesires of listPublicTeachersDesires; let i = index">
                        <div nz-col [nzSpan]="24" *ngIf="!teachersDesires.isRequiredNote">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                              <label nz-checkbox [ngModel]="teachersDesires.checked" (ngModelChange)="teachersDesiresChange($event,i)" [ngModelOptions]="{standalone :true}">{{ teachersDesires.name }}</label>
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                        <ng-container *ngIf="teachersDesires.isRequiredNote">
                          <div nz-col [nzSpan]="12">
                            <nz-form-item>
                              <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                <label nz-checkbox [ngModel]="teachersDesires.checked" (ngModelChange)="teachersDesiresChange($event,i)" [ngModelOptions]="{standalone :true}">{{ teachersDesires.name }}</label>
                              </nz-form-label>
                            </nz-form-item>
                          </div>
                          <div nz-col [nzSpan]="12">
                            <nz-form-item>
                              <nz-form-label [nzFor]="'field'">
                                <i class="fas fa-circle"></i>
                                Nhập khi chọn loại "khác"
                              </nz-form-label>
                              <nz-form-control>
                                <input nz-input [disabled]="!this.listPublicTeachersDesires[i].checked"/>
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btng-end">
                <button nz-button nzType="primary" (click)="update()">Hoàn thành</button>&nbsp;
                <button nz-button [routerLink]="['/',  'project']">Đóng</button>
              </div>
          </div>
      </nz-card>
    </div>
    <div nz-col nzSm="1" nzMd="1" nzLg="1" nzXl="2">
    </div>
  </div>
</form>